import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import moment from 'moment';
import Cookies from 'universal-cookie';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    CircularProgress,
    Fade,
    DialogContent,
    DialogActions,
    Dialog,
    TextField,
    Button
} from '@material-ui/core';
import {
    validateOTP,
    validateWholeOTP,
    phoneValidate
} from '../../utils/validators/validateForm';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NotificationManager } from 'react-notifications';

class Verification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            loaderMain: false,
            value: 0,
            phone: '',
            emailOtp: '',
            phoneOtp: '',
            showContent: 1,
            dashboardRedirect: false
        };
    }
    componentDidMount = async () => {
        this.setState({
            playerId: window.onesignalId
        });
    };
    handleClose = () => {
        this.props.close();
    };
    verifyActionCall = () => {
        if (this.state.showContent == 1) {
            if (validateWholeOTP(this.state.emailOtp, this.handleError)) {
                this.setState({ loaderButton: true });
                this.props.checkProviderOtpAction(
                    {
                        email: this.props.email,
                        otp: this.state.emailOtp
                    },
                    this.onEmailVerifyDone
                );
            }
        }
        // } else if (this.state.showContent == 2) {
        //     if (phoneValidate(this.state.phone, this.handleError)) {
        //         this.setState({ loaderButton: true });
        //         this.props.sendOtpOnPhoneAction(
        //             {
        //                 email: this.props.email,
        //                 phone: this.state.phone,
        //                 playerId: this.state.playerId
        //             },
        //             this.onPhoneDone
        //         );
        //     }
        // } else if (this.state.showContent == 3) {
        //     if (validateWholeOTP(this.state.phoneOtp, this.handleError)) {
        //         this.setState({ loaderButton: true });
        //         this.props.checkOtpOnPhoneAction(
        //             {
        //                 email: this.props.email,
        //                 otp: this.state.phoneOtp,
        //                 playerId: this.state.playerId
        //             },
        //             this.onPhoneVerifyDone
        //         );
        //     }
        // }
    };

    handleError = params => {
        this.setState(params);
    };

    onEmailVerifyDone = (success, data) => {
        if (success) {
            var cookies = new Cookies();
            if (!cookies.get('x-auth-token', { path: '/' })) {
                cookies.set('x-auth-token', data.token, { path: '/' });
            }
            this.setState({
                loaderButton: false,
                dashboardRedirect: true
            });
            // this.setState(function(previousState) {
            //     return {
            //         showContent: previousState.showContent + 1,
            //         loaderButton: false
            //     };
            // });
        } else {
            this.setState({
                loaderButton: false,
                verifyError: true,
                emailOtpError: data
            });
        }
    };

    onPhoneDone = (success, data) => {
        if (success) {
            this.setState(function(previousState) {
                return {
                    showContent: previousState.showContent + 1,
                    loaderButton: false
                };
            });
        } else {
            this.setState({
                loaderButton: false,
                verifyError: true,
                phoneError: data
            });
        }
    };

    onPhoneVerifyDone = (success, data) => {
        if (success) {
            var cookies = new Cookies();
            if (!cookies.get('x-auth-token', { path: '/' })) {
                cookies.set('x-auth-token', data.token, { path: '/' });
            }
            this.setState({
                loaderButton: false,
                dashboardRedirect: true
            });
        } else {
            this.setState({
                loaderButton: false,
                verifyError: true,
                phoneOtpError: data
            });
        }
    };
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: this.props.theme.palette.primary
                                .main,
                            color: '#ffffff',
                            fontSize: '16px'
                        }}
                        size="large"
                        onClick={this.verifyActionCall}
                    >
                        {this.state.showContent == 2 ? (
                            <FormattedMessage
                                id="sendOtp"
                                defaultMessage="Send OTP"
                            />
                        ) : (
                            <FormattedMessage
                                id="verify.title"
                                defaultMessage="Verify"
                            />
                        )}
                    </Button>
                    {this.state.verifyError && (
                        <Button
                            variant="outlined"
                            style={{
                                backgroundColor: this.props.theme.palette
                                    .primary.main,
                                color: '#ffffff',
                                fontSize: '16px'
                            }}
                            size="large"
                            onClick={this.handleClose}
                        >
                            <FormattedMessage
                                id="verify.close"
                                defaultMessage="Close"
                            />
                        </Button>
                    )}
                </div>
            );
        }
    };

    render() {
        if (this.state.dashboardRedirect) {
            NotificationManager.success(
                <FormattedMessage id="welcome" defaultMessage="Welcome" />,
                'Success'
            );
            this.props.history.push(`/user/dashboard`);
        }
        const {
            phoneError,
            emailOtpError,
            phoneOtpError,
            showContent,
            loaderButton
        } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={true}
                    className="service-modal verification-modal"
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <div className=" log-in-pop-right p-0">
                        <form className="dialog-form  form-new">
                            <div
                                className="modal-header dir-pop-head"
                                style={{
                                    backgroundColor: this.props.theme.palette
                                        .primary.main
                                }}
                            >
                                {showContent == 1 && (
                                    <React.Fragment>
                                        <h4 className="dialog-heading">
                                            <FormattedMessage
                                                id="verify.email"
                                                defaultMessage="Verify Email"
                                            />
                                        </h4>
                                    </React.Fragment>
                                )}
                                {showContent == 2 && (
                                    <h4 className="dialog-heading">
                                        <FormattedMessage
                                            id="verify.enterphone"
                                            defaultMessage="Enter Phone Number"
                                        />
                                    </h4>
                                )}
                                {showContent == 3 && (
                                    <h4 className="dialog-heading">
                                        <FormattedMessage
                                            id="verify.phone"
                                            defaultMessage="Verify Phone Number"
                                        />
                                    </h4>
                                )}
                            </div>

                            <div className="modal-body dir-pop-body">
                                <DialogContent className="service-from-body mb-4">
                                    <p>
                                        Please enter OTP sent to your
                                        email/phone here to verify
                                    </p>
                                    {showContent == 1 && (
                                        <TextField
                                            className="login-form-textfield"
                                            error={emailOtpError ? true : false}
                                            helperText={emailOtpError}
                                            label={formatMessage({
                                                id: 'verify.otp'
                                            })}
                                            id="emailOtp"
                                            fullWidth={true}
                                            name="emailOtp"
                                            type="text"
                                            value={this.state.emailOtp}
                                            onChange={event => {
                                                this.setState({
                                                    emailOtp:
                                                        event.target.value,
                                                    emailOtpError: ''
                                                });
                                            }}
                                            disabled={loaderButton}
                                        />
                                    )}
                                    {showContent == 2 && (
                                        <TextField
                                            className="login-form-textfield"
                                            error={phoneError ? true : false}
                                            helperText={phoneError}
                                            label={formatMessage({
                                                id: 'verify.phone'
                                            })}
                                            id="phone"
                                            fullWidth={true}
                                            name="phone"
                                            type="text"
                                            value={this.state.phone}
                                            onChange={event => {
                                                this.setState({
                                                    phone: event.target.value,
                                                    phoneError: ''
                                                });
                                            }}
                                            disabled={loaderButton}
                                        />
                                    )}
                                    {showContent == 3 && (
                                        <TextField
                                            className="login-form-textfield"
                                            error={phoneOtpError ? true : false}
                                            helperText={phoneOtpError}
                                            label={formatMessage({
                                                id: 'verify.otp'
                                            })}
                                            id="phoneOtp"
                                            fullWidth={true}
                                            name="phoneOtp"
                                            type="text"
                                            value={this.state.phoneOtp}
                                            onChange={event => {
                                                this.setState({
                                                    phoneOtp:
                                                        event.target.value,
                                                    phoneOtpError: ''
                                                });
                                            }}
                                            disabled={loaderButton}
                                        />
                                    )}
                                </DialogContent>

                                <DialogActions>
                                    <div className="col-md-12">
                                        {this.renderButton()}
                                    </div>
                                </DialogActions>
                            </div>
                        </form>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(null, actions)
);
export default composedHOC(injectIntl(withRouter(Verification)));



// WEBPACK FOOTER //
// ./src/components/Providers/Verification.jsx